export const STATS = '/stats';
export const INVENTORY = '/inventory';
export const SUPPLIER_BUCKETS = '/supplier-buckets';
export const DSO = '/dso';
export const SALES_SUMMARY = '/sales/summary';
export const SALES = '/sales';
export const UPLOAD_IMAGE = '/upload/image';
export const REDEEM_SESSION_URL = '/user/redeemsession';
export const SIGNUP = '/user/signup';
export const SUPPLIER = '/supplier/product';
export const LOGIN = '/user/login';
export const UPDATE_USER = '/user/update';
export const LOGOUT = '/user/logout';

export const ADD_SUPPLIER = '/user/supplier/add';
export const CHECK_SUPPLIER_LOGINS = '/user/suppliers';
export const VISITED_QUICK_ORDER = '/user/visitedqo';
export const PRODUCT_SUGGESTIONS = '';
export const PRODUCT_SEARCH = '/product/search';
export const PRODUCT_SEARCH_PUBLIC = '/product/search_public';
export const BULK_PRICING = '/pricing/bulk';
export const BULK_PRICING_RETRY = '/pricing/bulkretry';
export const EDIT_CART = '/cart/edit';
export const CLEAR_CART = '/cart/clear';
export const GET_PROMOS = '/promo';
export const GET_PROMO_PRODUCTS = '/promo/';
export const GET_PRODUCT_PROMOS = '/promo/product/';
export const GET_LISTS = '/lists';
export const GET_LIST_PRODUCTS = '/listproducts';
export const GET_ORDERS = '/orders';
export const GET_RECENT_ORDERS = '/orders/dentira/recent';
export const MARK_ORDER_AS_DELIVERED = '/orders';
export const GET_ORDER_DETAILS = '/orders';
export const CREATE_LIST = '/lists';
export const GET_PRODUCT_LISTS = '/product';
export const ADD_PRODUCT_TO_LIST = '/product/addtolist';
export const REMOVE_PRODUCT_TO_LIST = '/product/removefromlist';
export const CREATE_LIST_AND_ADD_PRODUCT = '/lists/create_and_add_product';
export const COMMIT_CART = '/cart/commit';
export const PLACE_ORDER = '/orders';
export const GET_PRODUCT_DETAILS = '/product';
export const GET_SHIPPING_DETAILS = '/cart/shippingdetails';
export const SHIPPING_METHODS = '/cart/shippingmethods';
export const LOGIN_WITH_GOOGLE = '/user/loginorsignupwithgoogle';
export const GET_SUPPLIER_USERNAME = '/user';
export const HOMEPAGE_STATIC_PRODUCTS = '/ui-config/ui-config.json';
export const SUPPLIERS_CONFIG = '/ui-config/suppliers.json';
export const UI_CONFIG = '/ui-config/ui-config.json';
export const HOMEPAGE_PURCHASED_PRODUCTS = '/history/products';
export const STATIC_DATA_URL = '/config/data';
export const INVALID_PASSWORD_BOT_URL = '/bot/invalidpassword';
export const ANALYTICS_DATA_URL = '/history/analytics';
export const SUPPLIER_SHIPPING_METHODS = '/cart/setshipping';
export const SUPPLIER_GET_SAVE_CARDS = '/cart/creditonfile';
export const CART_SESSION_CHECK = '/cart/checksession';
export const PASSWORD_RESET_LINK_GENERATION_ENDPOINT = '/user/sendResetPassLink';

export const PRICE_FROM_CART = '/cart/pricefromcart/';
export const SUPP_PRICES_FROM_CART = '/cart/suppliercartprices';
export const ITEM_HISTORY_URL = '/history/items';
export const PRODUCT_RECENT_VIEWS_URL = '/product/recentviews/top';
export const GET_TOP_SELL = '/product/global/topsellers';
export const GET_HOMEPAGE_POPULAR_PRODUCTS = '/config/homepageproducts';
export const POST_REFERRAL_MAIL = '/referral/invitewithemail';

export const POST_OFFER_POPUP_SEEN = '/user/offerpopupseen';
export const SUPPLIER_GET_ALL_SHIP_ADDR = '/cart/alladdresses';
export const SUPPLIER_CHECK_PO = '/cart/checkpo';
export const GET_CART = '/cart';

export const GET_INVENTORY = '/inventory';
export const GET_STORAGE = '/inventory/storage';
export const ADD_STORAGE = '/inventory/storage/add';
export const RENAME_STORAGE = '/inventory/storage/rename';
export const PRODUCT_LOOKUP = '/product/lookup';
export const ADD_INVENTORY_ITEM = '/inventory/add';
export const GET_INV_DASHBOARD = '/inventory/dashboard';

export const POST_GUEST_INFO = '/bot/demorequest';

export const CREATE_GROUP = '/group/create';
export const UPDATE_GROUP = '/group/update';
export const GET_GROUP = '/group/details';
export const GET_LAB_REBATE_CONFIG = '/lab/details';
export const ADD_GROUP_PRODUCT = '/group/addproducts';
export const ADD_GROUP_PRODUCT_FILE = '/group/addproductsfile';
export const DELETE_GROUP_PRODUCT = '/group/';
export const GET_GROUP_PRODUCTS = '/group/products';
export const IMPORT_LIST_TO_GROUP = '/group/importlist';
export const UPLOAD_GROUP_LOGO = '/upload/image';
export const INVITE_TO_GROUP = '/group/invite';
export const GET_LOCATIONS = '/group/locations';
export const UPDATE_LOCATION = '/group/updatelocation';
export const GET_DASHBOARD_DATA = '/group/dashboard';
export const GET_GROUP_NOTIFICATIONS = '/groupnotifications';
export const UPDATE_GROUP_INVITATION_STATUS = '/group/updateinvstatus';
export const PLACE_ORDER_FOR_APPROVAL = '/orders/forapproval';
export const GET_GROUP_ORDERS = '/group/locations/orders';
export const REQUEST_JOIN_GROUP = '/group/joinrequest';
export const PROCESS_REQUEST_JOIN_GROUP = '/group/approverequest';
export const NOTIFICATION_MARK_AS_VIEWED = '/groupnotifications';
export const GET_CONVERSATION = '/groupnotifications/conversations';
export const UPDATE_CONVERSATION = '/groupnotifications/updateconversation';
export const START_CONVERSATION = '/groupnotifications/startconversation';
export const UPDATE_LOCATION_ROLE = '/group/updatelocrole';
export const USER_GRP_ORDER_VALIDATION = '/user/groupordervalidation';
export const MARK_AS_LOCATION = '/group/checkupdateloc';
export const GET_LOCATION_INFO = '/group/locationinfo';
export const GET_GROUP_ORDERS_INVOICE = '/group/grouporderinvoces';

export const SAVE_PARTNER_DETAILS_URL = '/user/partner';
export const ALERT_SUPPLIER_LINKING_TIMEOUT_URL = '/user/supplier/alarm/timeout';

export const FETCH_FILE_UPLOAD_URL = '/presign/upload';
export const FETCH_AUTOCOMPLETE_MANUFACTURER = '/auto-complete/manufacturer';
export const FETCH_AUTOCOMPLETE_MANUFACTURER_V2 = '/auto-complete/manufacturer/v2';
export const FETCH_AUTOCOMPLETE_SUPPLIER = '/auto-complete/supplier';
export const FETCH_AUTOCOMPLETE_PACKAGING = '/auto-complete/packaging';
export const FETCH_AUTOCOMPLETE_GROUP_IDS = '/auto-complete/group-ids';
export const FETCH_AUTOCOMPLETE_CATEGORY = '/auto-complete/category';
export const FETCH_AUTOCOMPLETE_SUBCATEGORY = '/auto-complete/subcategory';
export const FETCH_AUTOCOMPLETE_SUBSUBCATEGORY = '/auto-complete/subsubcategory';
export const FETCH_AUTOCOMPLETE_CATEGORY_V2 = '/auto-complete/category/v2';
export const FETCH_AUTOCOMPLETE_SUBCATEGORY_V2 = '/auto-complete/subcategory/v2';
export const FETCH_AUTOCOMPLETE_SUBSUBCATEGORY_V2 = '/auto-complete/subsubcategory/v2';
export const FETCH_AUTOCOMPLETE_DENTIRA_PRODUCTS = '/auto-complete/dentira-products';
export const FETCH_AUTOCOMPLETE_DENTIRA_PRIMARY_PRODUCTS = '/auto-complete/dentira-primary-products';
export const FETCH_AUTOCOMPLETE_DENTIRA_ADDONS_PRODUCTS = '/auto-complete/dentira-addons-products';

export const FETCH_SPJ = '/seller-portal-jobs';

export const GET_ALL_SUPPLIERS = '/supplier/all';
export const GET_SUPPLIER_MAP = '/supplier/map';

export const FETCH_PROCEDURES = '/utils/procedures';
export const FETCH_PROCEDURE_ENUMS = '/utils/procedure_enums';
export const FETCH_DENTIRA_PRODUCT_ID_TO_NAME_MAP = '/utils/dentira_product_id_to_name_map';
export const FETCH_DENTIRA_PRODUCT_CATEGORIES = '/utils/dentira-products/categories';
export const FETCH_DENTIRA_PRODUCT_FILTERS = '/utils/dentira-products/filters';

export const FETCH_RECOMMENDED_AI_SKU_MAPPINGS = '/ai-sku-mapping';